import { apiCall, apiPrefix } from "@services/API/Requests";
import { handleResponse } from "@services/API/StatusCodes";

export const getRoleData = async (
  setRoleData: (data: any) => void,
  setError: (error: any) => void,
  setLoading: (loading: boolean) => void,
) => {
  return apiCall({
    method: "get",
    url: `${apiPrefix}/roles/`,
    setLoading,
    onSuccess: (response) => {
      const roleData = response.data.map((role) => ({
        id: role.id,
        name: role.name,
        type: role.role_type,
      }));

      setRoleData(roleData);
      return handleResponse(response, "ロール");
    },
    onError: (errorResponse) => {
      const error =
        errorResponse.errors || errorResponse.error || errorResponse;
      setError(error);
    },
  });
};
